import Vue from "vue"
import App from "./App.vue"
import store from "./store"
import VueSocketIO from "vue-socket.io"

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== "production",
    connection: process.env.VUE_APP_WS_LIVE_URL,
    vuex: {
      store,
      actionPrefix: "ws_",
    },
    options: {
      useConnectionNamespace: true,
      autoConnect: false,
    },
  })
)

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== "production",
    connection: "ws://localhost:5000/local",
    vuex: {
      store,
      actionPrefix: "wsppt_",
    },
    options: {
      useConnectionNamespace: true,
      autoConnect: false,
    },
  })
)

import "./assets/styles/index.css"

Vue.config.productionTip = false

// https://www.npmjs.com/package/vue-toasted
import Toasted from "vue-toasted"
Vue.use(Toasted)

// options to the toast
let options = {
  position: "top-center",
  type: "error",
  action: {
    text: "Ok",
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    },
  },
}

// register the toast with the custom message
Vue.toasted.register(
  "smartq_error",
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Oops.. Something Went Wrong.."
    }

    // if there is a message show it with the message
    return "Oops.. " + payload.message
  },
  options
)

// https://docs.sentry.io/error-reporting/quickstart/?platform=browsernpm
import * as Sentry from "@sentry/browser"
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://a637f5072a5e479080d583ab0962a8d4@o187540.ingest.sentry.io/1875090",
  })
}

export { Vue, App, store }
